'use client';
import React from 'react';
import { YCoordinatePopup } from './YCoordinatePopup';
import { PlaceOrderPopup } from './PlaceOrderPopup';
import { ShapeType } from '@/types/commontypes';
import { useChartShapes, useChartUIContext } from '../../contexts';
import { useChartUIStoreSelector } from '../../stores/chartUIStore';
import { useGlobalShapeSelector } from '../../contexts/GlobalShapesContext';

/**
 * Handles rendering and logic for both YCoordinatePopup and PlaceOrderPopup.
 * Keeps CandlestickChart cleaner.
 */
export const PopupManager: React.FC = () => {
  const { chartUIStore } = useChartUIContext();
  const activePopup = useChartUIStoreSelector(chartUIStore, s => s.activePopup);
  const chartInfos = useChartUIStoreSelector(chartUIStore, s => s.chartInfos);
  const hedgeMode = useGlobalShapeSelector(s => s.hedgeMode);

  const { renderNodes } = useChartShapes();

  if (!activePopup) return null;

  if (activePopup.type === 'y-popup') {
    const isCandleChart =
      chartInfos.find((c: { chartId: string; isCandleChart?: boolean }) => c.chartId === activePopup.chartId)
        ?.isCandleChart ?? false;
    const hasOrderLines = !!renderNodes[activePopup.chartId]?.[ShapeType.ORDER_LINE]?.length;
    // hedgeMode ON: 오더라인이 있어도 메뉴 표시 (버튼별 차단은 YCoordinatePopup 내부에서 처리)
    // hedgeMode OFF: 오더라인 없을 때만 메뉴 표시
    const showOrderMenu = isCandleChart && (!hasOrderLines || hedgeMode);
    return <YCoordinatePopup showOrderMenu={showOrderMenu} />;
  }

  if (activePopup.type === 'order-popup') {
    return <PlaceOrderPopup />;
  }

  return null;
};
